import cn from 'classnames';
import parse from 'html-react-parser';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import { Actions } from '@components/Pages/ProfilePages/Actions/Actions';
import { Stats } from '@components/Pages/ProfilePages/Stats/Stats';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { useHeaderHeight } from '@hooks/useHeaderHeight/useHeaderHeight';
import { MAX_DESCRIPTION_LENGTH } from '@services/user/constants';
import { SocialManagerView } from '@specs/views';
import { RenderButton } from './Buttons/RenderButton';
import s from './info.module.scss';
const ExpandableText = dynamic(import('@components/UIKit/ExpandableText/ExpandableText').then(module => module.ExpandableText), {
  ssr: false
});
interface Props extends SocialManagerView.publicProfile {
  isMyProfile: boolean;
}
export const Info: FC<Props> = ({
  avatar,
  shortid,
  isMyProfile,
  description,
  id
}) => {
  const headerHeight = useHeaderHeight();
  return <div className={s.info} style={{
    top: `${headerHeight}px`
  }} data-sentry-component="Info" data-sentry-source-file="Info.tsx">
            <Avatar className={s.info__avatar} srcSet={[{
      height: 156,
      width: 156,
      minMedia: 767.98
    }, {
      height: 66,
      width: 66,
      minMedia: 0
    }]} profile={{
      avatar,
      shortid
    }} isLoading={false} data-sentry-element="Avatar" data-sentry-source-file="Info.tsx" />
            <div className={s.info__header}>
                <div className={s.info__row}>
                    <div className={cn(s.info__name, '_ellipsis')}>
                        {shortid}
                    </div>
                    <div className={cn(s.info__headerButtons)}>
                        <RenderButton shortid={shortid} isMyProfile={isMyProfile} id={id} data-sentry-element="RenderButton" data-sentry-source-file="Info.tsx" />
                    </div>
                    <div className={cn(s.info__actions, '_tablet_min')}>
                        <Actions shortid={shortid} isMyProfile={isMyProfile} data-sentry-element="Actions" data-sentry-source-file="Info.tsx" />
                    </div>
                </div>
                <Stats shortid={shortid} data-sentry-element="Stats" data-sentry-source-file="Info.tsx" />
            </div>
            {description && <div className={s.info__description}>
                    <ExpandableText boxClassName={'_tablet_min'} text={description} maxLength={MAX_DESCRIPTION_LENGTH} />
                    <span className={'_tablet'}>{parse(description)}</span>
                </div>}
            <div className={s.info__footer}>
                <RenderButton shortid={shortid} isMyProfile={isMyProfile} id={id} data-sentry-element="RenderButton" data-sentry-source-file="Info.tsx" />
            </div>
        </div>;
};